import { Button, Intent, Position } from '@blueprintjs/core';
import { Tooltip2 } from '@blueprintjs/popover2';
import {
  SM_PROVIDER_META,
  StartingMaterialDatasetProvider,
  StartingMaterialDatasetProviders,
  StartingMaterialPriceItem,
} from '@retro-ui/shared';
import { useSelector } from 'react-redux';

import { useSciFinderSupplier } from '@f/hooks';
import { useBaseSupplier } from '@f/hooks/useBaseSupplier';

const supplierHook = (provider: StartingMaterialDatasetProvider) => {
  switch (provider) {
    case StartingMaterialDatasetProviders.Cas:
      return useSciFinderSupplier;
    default:
      return useBaseSupplier;
  }
};

interface SuppliersLinkProps {
  compound: StartingMaterialPriceItem;
  provider: StartingMaterialDatasetProvider;
}

export function SuppliersLink(props: SuppliersLinkProps) {
  const { compound, provider } = props;

  const userEmail = useSelector((state: any) => state.authentication.user.email);

  const providerMeta = SM_PROVIDER_META[provider];
  const { name, generateLink } = providerMeta;

  const useSupplier = supplierHook(provider);
  const { isLoading, openSuppliers } = useSupplier();

  const onOpenSuppliers = () => {
    if (provider === StartingMaterialDatasetProviders.Cas) {
      void openSuppliers(compound.casNumber);
    } else {
      void openSuppliers(generateLink(compound, userEmail));
    }
  };

  return (
    <Tooltip2
      content={
        <>
          Open the supplier list in {name}
          <br />
          <small>Please allow RetroScore to open popup windows if prompted.</small>
        </>
      }
      position={Position.TOP}
      hoverOpenDelay={500}
    >
      <Button
        intent={Intent.PRIMARY}
        minimal
        loading={isLoading}
        text={`Find more in ${name}`}
        rightIcon="share"
        onClick={onOpenSuppliers}
      />
    </Tooltip2>
  );
}
